import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { Select } from 'components/forms';
import { RULES_SORT_PARAMS as sortByOptions } from 'constants/rules';
import useSearchRules from 'hooks/useSearchRules';

const Sort = () => {
  const { getRules } = useSearchRules();
  const [searchParams, setSearchParams] = useSearchParams();

  const onChange = (newValue?: string | string[]) => {
    if (typeof newValue === 'string') {
      searchParams.set('sort', newValue);

      getRules([
        { page: 1 },
        { sort: newValue },
      ]);
    }

    if (!newValue) {
      searchParams.delete('sort');
      getRules([{ page: 1 }]);
    }

    setSearchParams(searchParams);
  };

  const sortBy = searchParams.get('sort') || undefined;

  return (
    <Select
      options={sortByOptions}
      value={sortBy}
      onChange={onChange}
      placeholder="Сортировать..."
      isClearable
      isSearchable={false}
    />
  );
};

export default Sort;
